import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core'

@Component({
  selector: 'dhp-filter-item',
  templateUrl: './filter-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [],
})
export class FilterItemComponent {
  readonly name = input.required<string>()
  readonly selected = input(false)
  readonly itemSelected = output()

  onClick(event: Event): void {
    // Prevent default behavior and stop propagation
    event.preventDefault()
    event.stopPropagation()

    // Emit the selection event
    // TODO: The 'emit' function requires a mandatory void argument
    this.itemSelected.emit()
  }
}
